import { VARIANT } from "./variant";

export const PROMPT_TYPE = {
  ...VARIANT,
  CONFIRMATION: "confirmation",
};
